import React from 'react'
import { PrivateLayout } from './base-private.layout'
import { RoleConstants } from '../../constants'

export const ClientLayout = ({ children }) => (
	<PrivateLayout role={RoleConstants.Client} children={children} />
)

export const EmployeeLayout = ({ children }) => (
	<PrivateLayout role={RoleConstants.Admin} children={children} />
)

export const PartnerLayout = ({ children }) => (
	<PrivateLayout role={RoleConstants.Partner} children={children} />
)
